import React, { useContext, useEffect, useState } from "react";
import shipment from "../../assest/images/cargo.png";
import { UserContext } from "../common/UserContext";
import axios from "axios";
import config from "../../envconfig";
import orders from '../../assest/images/order-delivery.png';
import box from '../../assest/images/box.png';
import { Navigate } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { MdOutlinePendingActions } from "react-icons/md";
import { TbClockPin } from "react-icons/tb";
import { TbTruckDelivery } from "react-icons/tb";
import { BsTruck } from "react-icons/bs";
import { FaTruck } from "react-icons/fa";
import { FaTruckFast } from "react-icons/fa6";
import { LiaShippingFastSolid } from "react-icons/lia";
import { TbPackageExport } from "react-icons/tb";
import { FaClipboardCheck } from "react-icons/fa";

const Card = ({ title, image, icon, value }) => {
    const navigate = useNavigate();

    const cardClick = (title) => {
        // You can replace this console.log with any other action you want to perform
        console.log(`Card clicked: ${title}`);
        if (title === "Pending Shipment Approval") {
            navigate('/dashboard/shipmentapproval')
        }
        if (title === "Pending Orders Shipment") {
            navigate('/dashboard/shipment')
        }
        if (title === "Pending Order Approval") {
            navigate('/dashboard/OrderVerification')
        }
        if (title === "Pending Outward") {
            navigate('/ShipOutScanPendingList')
        }
    };


    return (
        <div className="flip-card" onClick={() => cardClick(title)}>
            <div className="flip-card-inner">
                <div className="flip-card-front">
                    <div className="card-row title-row">
                        <p className="title">{title}</p>
                    </div>
                    <div className="card-row image-row" style={{ fontSize: "40px", color: "#fff", fontWeight: '100' }}>
                        {icon}
                    </div>

                    <div className="card-row value-row">
                        <p style={{ fontSize: '1em', color: '#fff', fontWeight: '500' }}>
                            {value}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};



const Cards = () => {
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
    const [shipmentData, setShipmentData] = useState({});

    useEffect(() => {
        const fetchShipmentInfo = async () => {
            try {
                const response = await axios.get(`${config.API_URL}/shipment-info?scpCode=${selectedScpId}`);
                setShipmentData(response.data);
                console.log("DATA::::::::::::::::::::", response.data);
            } catch (err) {
                console.log("ERROR:", err);
            }
        };

        if (selectedScpId) {
            fetchShipmentInfo();
        }
    }, [selectedScpId]);

    // const cardData = [
    //     {
    //         title: "Pending Shipment Approval",
    //         icon: <MdOutlinePendingActions />,
    //         key: "Pending_Approval",
    //     },
    //     {
    //         title: "Shipment In Transist",
    //         icon: <LiaShippingFastSolid />,
    //         key: "In_Transit",
    //     },
    //     {
    //         title: "Pending Orders Shipment",
    //         icon: <TbPackageExport  />,
    //         key: "MissingOrderCount",
    //     },
    //     {
    //         title: "Pending Order Approval",
    //         icon: <FaTruck />,
    //         key: "Pending_Order_Approval",
    //     },
    //     {
    //         title: "Pending Outward",
    //         icon: <TbClockPin />,
    //         key: "Pending_Outward",
    //     },
    // ];

    const cardData = [
  {
    title: "Pending Shipment Approval",
    icon: <MdOutlinePendingActions />,
    key: "Pending_Approval",
  },
  {
    title: "Shipment In Transit",
    icon: <LiaShippingFastSolid />,
    key: "In_Transit",
  },
  {
    title: "Pending Orders Shipment",
    icon: <TbPackageExport />,
    key: "MissingOrderCount",
  },
  {
    title: "Pending Order Approval",
    icon: <FaClipboardCheck />,
    key: "Pending_Order_Approval",
  },
  {
    title: "Pending Outward",
    icon: <TbClockPin />,
    key: "Pending_Outward",
  },
];


    return (
        <div className="cards">
            {cardData.map((card, index) => (
                <Card
                    key={index}
                    title={card.title}
                    icon={card.icon}
                    value={shipmentData[card.key] || 0} // Default to 0 if no value is found
                />
            ))}
        </div>
    );
};

export default Cards;
